import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-uhbvn-noc-upload',
  templateUrl: './uhbvn-noc-upload.component.html',
  styleUrls: ['./uhbvn-noc-upload.component.scss']
})
export class UhbvnNocUploadComponent implements OnInit {

  public ownMIfarmerDetailsForm: FormGroup;
  public userId: any;

  public uploadedBillFiles: any[] = [];

  public ipAddress: any = '000.000.000';
  public jeList: any = [];
  
  constructor(
    public router: Router,
    private fb: FormBuilder,
    private loader: AppLoaderService,
    private fApplicationService: FarmersApplicationService,
    private messageService: MessageService,
    private _personalDetalSer: FarmersDetailsService,
    private ipService: IpAddressService,
    private reportService: ReportsService,
    private deptDashBoardService: DepartmentDashboardService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.getIP();
    this.getJEList();

    this.ownMIfarmerDetailsForm = this.fb.group({
      appNo: ['', [Validators.required]],
      nocPath: ['', Validators.required],
      je: ['', Validators.required],
      remarks: ['', Validators.required],
    });
  }

  getJEList() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loader.start();
    this.deptDashBoardService
      .getJEUserIds(JSON.parse(payload)?.sub)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.jeList = data;
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success Message',
          //   detail: data.toString(),
          // });
        },
        error: (err) => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Next level user not found. ${err}`,
          });
        },
      });
  }

  onBillUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let phNo = farmerconfData.get('ownMIfarmerPh') ? farmerconfData.get('ownMIfarmerPh') : '';

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, phNo, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedBillFiles = [];
          for (let file of event.files) {
            this.uploadedBillFiles.push(file);
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Bill Uploaded Successfully',
          });
          this.ownMIfarmerDetailsForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onSubmitfarmerOwnMIDetails() {
    if (!this.ownMIfarmerDetailsForm.invalid) {
      let val = this.ownMIfarmerDetailsForm.value;
      let reqBody = {
        nocPath: val?.nocPath,
        appId: val?.appNo,
        je: val?.je,
        remarks: val?.remarks,
        userId: this.userId,
        networkId: this.ipAddress,
        terminalId: this.ipAddress
      }

      this.submitDetails(reqBody);
      // this.checkAppVal(reqBody);
    } else {
      this.ownMIfarmerDetailsForm.markAllAsTouched();
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Fill all madatory details.',
      });
    }
  }

  checkAppVal(reqBody){
    this.loader.start();
    this.fApplicationService
      .getUHBVNData(reqBody?.appId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res[0]?.Message == 'Application Found') {
            // this.messageService.add({
            //   severity: 'success',
            //   summary: 'Success Message',
            //   detail: res,
            // });

            this.submitDetails(reqBody);

          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res[0]?.Message,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  submitDetails(reqBody) {
    this.loader.start();
    this.fApplicationService
      .uploadUHBVNFieldXENNoc(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res,
            });
            this.ownMIfarmerDetailsForm.reset();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

}
